
import styled from "styled-components";
import { BsSearch } from 'react-icons/bs'
export const Container = styled.div`
    display: flex;
    flex-shrink:1;
    font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
`

export const GContainer = styled.div`
    padding-top: 40px;
    padding-bottom: 16px;
    display: grid;
    grid-template-columns: 100%;
    font-family: work sans, "Open Sans", Helvetica, Arial, sans-serif !important;
`
export const Container1 = styled.div`
    display: flex;
    flex-shrink:1;
    font-family: Montserrat SemiBold, "Open Sans", Helvetica, Arial, sans-serif !important;
`

export const Heading = styled.div`
font-size: 1.125rem;
font-weight: 600;
color: #312d2d;
cursor:pointer;
margin:17px 0 0 8px;
line-height: 20px;
font-family: work sans, "Open Sans", Helvetica, Arial, sans-serif !important;
@media (max-width: 1145px) {
    font-size: 1.125rem !important;
  } 
@media (max-width: 794px) {
    font-size: 1rem !important;
  } 
`
export const Seachbar = styled.div`
position: relative;
flex-shrink: 1;
flex-grow: 1;
display: flex;
align-items: center;
background-color: white;
cursor:pointer;
border: none;
border-radius: 9999px;
width:100%;
min-height: 52px;
padding: 10px 22px;
box-sizing: border-box;
box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
font-family: work sans, "Open Sans", Helvetica, Arial, sans-serif !important;
`

export const Input = styled.input`
width: 100%;
border: none !important;
padding: 0 !important;
margin: 0;
font-size: 15px;
font-weight: 400;
font-family: work sans, "Open Sans", Helvetica, Arial, sans-serif;
color: #58595b;
background: transparent;
outline: none !important;
&::placeholder {
  color: #9ca3af;
  font-weight: 400;
  font-family: work sans, "Open Sans", Helvetica, Arial, sans-serif;
}
`
export const CustomBsSearch = styled(BsSearch)`
position: static;
flex-shrink: 0;
font-size: 18px;
color: #9ca3af;
margin-right: 12px;
`

export const MobileNav = styled.div`
  display:none;
  opacity:0;
  visibility; hidden;
  @media(max-width:990px){
    display:block;
    opacity:1;
    visibility; visible;
    position : fixed;
    top:0;
    width:100%;
    left:0;
    padding:20px 20px 20px 0;
    mix-blend-mode:normal;
    background:#fff;
    z-index:9999;
    img {
      position:relative;
      width: 77px;
      top: 0;
      left: 30px;

    }
  }
`
export const ToggleMenu = styled.div`
    display: inline-block;
    text-align:right;
    span{
    display: block;
    height: 5px;
    width: 44px;
    background: #2196f3;
    margin-bottom: 7px;
    border-radius: 49px;
    transition: all 0.3s ease 0s;
  }
    &.activeToggle{
      span:nth-child(1){
        transform: rotateZ(45deg);
        right: 0px;
        position: relative;
        top: 12px;
      }
      span:nth-child(2){
        display:none;
      }
      span:nth-child(3){
        transform: rotateZ(-45deg);
        position: relative;
        top: 1px;
        right: 1px;
      }
    }
`